import React, { Suspense, lazy, useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import { useRouter } from './lib/router';

const MainApp = lazy(() => import('./MainApp'));

export default function App() {
  const { path } = useRouter();
  
  // Show a skeleton while MainApp (and heavy JS) loads
  return (
    <Suspense 
      fallback={
        <div className="relative min-h-screen bg-[#F8FAFC] text-[#1E293B] overflow-hidden" dir="rtl">
          <Navbar 
            profileImage={null} 
            onAddPropertyClick={() => {}} 
            onDashboardClick={() => {}} 
            favoritesCount={0} 
            onShowFavoritesOnly={() => {}} 
            isShowingFavorites={false} 
            userSession={null} 
            onAuthClick={() => {}} 
            onLogout={() => {}} 
            onProfileEditClick={() => {}} 
            currentPage={path === '/browse' ? 'browse' : (path === '/favorites' ? 'favorites' : 'home')}
            onNavigate={() => {}}
          />
          <div className="pt-32 pb-12 flex flex-col items-center justify-center min-h-[60vh] space-y-4">
             <div className="w-12 h-12 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
             <p className="text-sm text-gray-500 font-medium">جاري تحميل التطبيق...</p>
          </div>
        </div>
      }
    >
      <MainApp />
    </Suspense>
  );
}
